const ImageRotator = {
  container: null,
  image: null,
  prevGamma: 0,
  createImage(containerCssId, imageCssId, style) {
    this.container = document.getElementById(containerCssId);
    this.image = this.container.querySelector(`#${imageCssId}`);
    const frameCount = style?.indexOf('Kid') !== -1 ? 5 : 7;
    const { imageWidth, frameWidth } = this.determineDimensions(frameCount);
    this.attachListener(imageWidth, frameWidth, frameCount);
  },
  determineDimensions(frameCount) {
    const { container, image } = this;
    let imageWidth = (image.naturalWidth / window.innerWidth) * 100;
    const imageMaxWidth = (container.offsetWidth / window.innerWidth) * 100 * frameCount;
    if (imageMaxWidth < imageWidth) {
      imageWidth = imageMaxWidth;
    }
    const frameWidth = imageWidth / frameCount;
    image.style.width = `${imageWidth}vw`;
    const centerFrame = frameCount === 7 ? 3 : 2;
    image.style.left = `${-(imageWidth / frameCount) * centerFrame}vw`;
    container.style.width = `${imageWidth / frameCount}vw`;
    return { imageWidth, frameWidth };
  },
  attachListener(imageWidth, frameWidth, frameCount) {
    const { image } = this;
    const orientationEv =
      ('ondeviceorientation' in window && 'deviceorientation') ||
      ('onMozOrientation' in window && 'MozOrientation');
    image.addEventListener(
      'mousemove',
      this.rotateHandler({ imageWidth, frameWidth, frameCount }),
      false
    );
    image.addEventListener(
      'touchmove',
      this.rotateHandler({ imageWidth, frameWidth, frameCount }),
      false
    );
    window.addEventListener(
      orientationEv,
      this.orientationHandler({ imageWidth, frameCount }),
      false
    );
  },
  rotateHandler({ imageWidth, frameWidth, frameCount }) {
    const { container, image } = this;
    const containerLeft = container.getBoundingClientRect().left;
    return event => {
      const pageX = event.type === 'touchmove' ? event.touches[0].pageX : event.pageX;
      const positionX = ((pageX - containerLeft) / window.innerWidth) * 100;
      const parentOffsetX = (container.offsetLeft / window.innerWidth) * 100;
      const offset = this.getOffset(frameWidth, positionX, frameCount, parentOffsetX);
      image.style.left = `${-(imageWidth / frameCount) * offset}vw`;
    };
  },
  orientationHandler({ imageWidth, frameCount }) {
    return event => {
      if (Math.abs(this.prevGamma - event.gamma) > 10) {
        this.prevGamma = event.gamma;
        let offset = event.gamma / 10;
        offset = offset < 0 ? Math.ceil(offset) : Math.floor(offset);
        if (offset > 3 || offset < -3) {
          return;
        }
        const centerFrame = frameCount === 7 ? 3 : 2;
        this.image.style.left = `${-(imageWidth / frameCount) * (centerFrame + offset)}vw`;
      }
    };
  },
  getOffset(frameWidth, positionX, frameCount, parentOffsetX) {
    const frameOffset = frameWidth / frameCount;
    for (let i = 0; i < frameCount; i += 1) {
      if (frameOffset * i < positionX && positionX < frameOffset * (i + 1) + parentOffsetX) {
        return i;
      }
    }
  },
  unmount() {
    const { image } = this;
    image.removeEventListener('mousemove', this.rotateHandler);
    image.removeEventListener('touchmove', this.rotateHandler);
  },
};

export default ImageRotator;
